/* istanbul ignore file */
import React, { ReactElement, useEffect, useState } from "react";
import { Card, Label, useRequestInit, TextEditor} from "adviesbox-shared";
import { connect, useFormikContext } from "formik";
import { FlattendElementType, RapportageState } from "./infra/rapportage-schema";
import { getRapportageTags } from "./infra/rapportage-tags-api";
import { ReplaceableTagInfo } from "../.generated/rapportage/rapportagetypes";

type Props = { selected: number };

const RapportageDetails = ({ selected }: Props): ReactElement => {
  const formik = useFormikContext<RapportageState>();
  const { settings, user } = useRequestInit();
  const [tags, setTags] = useState<ReplaceableTagInfo[]>([]);
  const elementen = formik.values.elementen;

  useEffect(() => {
    const fetchTags = async () : Promise<void> => {
      try {
        const fetchedTags = await getRapportageTags(settings, user);
        setTags(fetchedTags);
      } catch (error) {
        setTags([]);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchTags();
  }, [settings, user]);

  const selectedElement = elementen[selected];
  const tekstblokkenIndexen: number[] = [];
  elementen.forEach((element, index) => {
    if (element.soortElement === "Tekstblok" && element.ParentCode === selectedElement.code) {
      tekstblokkenIndexen.push(index);
    }
  });

  return (
    <div className="col-6 col-md-6">
      <Card title={selectedElement?.naam}>
        {tekstblokkenIndexen.length < 1 && <div className="p-1">Geen aanpasbare items beschikbaar</div>}
        {tekstblokkenIndexen.length > 0 &&
          tekstblokkenIndexen?.map(x => (
            <div className="p-3 tekstblokOption" key={`elementen-${x}-inhoud`}>
              <Label caption={elementen[x].naam} />
              <TextEditor
                name={`elementen[${x}.inhoud`}
                placeholder="Klik hier om jouw advies in te voeren"
                useTextEditor={true}
                rows={5}
                className="fit-content"
                readOnly={!elementen[x].perAdviesAanpasbaar}
                tags={tags.map(tagInfo => ({ label: tagInfo.description || tagInfo.tag || "", value: tagInfo.tag || "" }))}
              />
            </div>
          ))}
      </Card>
    </div>
  );
};

export default connect<Props, FlattendElementType>(RapportageDetails);
